<h1 mat-dialog-title i18n="@@input-dialog-example.title" oneDialogTitle>Set status to "Complete"</h1>
<div mat-dialog-content oneDialogContent class="localid-dialog-content">
<p class="subheading">Are you sure you want to set the status of this notification to "Complete"? The recipients will not be able to provide feedback anymore.</p>

</div>
<div mat-dialog-actions oneDialogActions>
    <button one-secondary-button mat-stroked-button [mat-dialog-close]="false"
        i18n="@@input-dialog-example.no-thanks-btn">
        Cancel
    </button>
    <button color="primary" mat-flat-button [mat-dialog-close]="false" i18n="@@input-dialog-example.ok-btn" (click)="changeStatus()">
        Yes, set to "Complete"
    </button>
</div>